import styled from 'styled-components';

import { Link } from 'core/routing';
import { Icon } from 'components';

export const EnvironmentStyled = styled.strong`
  font-weight: ${props => props.theme.font.weight.regular};
  text-transform: capitalize;
  display: inline-flex;
  align-items: baseline;
`;

export const LinkStyled = styled(Link)`
  color: ${props => props.theme.color.wfBlue};
  &:hover {
    text-decoration: underline;
  }
`;

export const IconStyled = styled(Icon)`
  margin: 0 ${props => props.theme.spacing.xsmall} 0 0;
`;
